import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { API } from "./api/apiSlice";
import HomePage from "./pages/HomePage";
import ThankYou from "./pages/ThankYou";

function App() {
  const [feedback, setFeedback] = useState([]);
  const [title, setTitle] = useState("");
  const fromLocalStorageFeedbacks = JSON.parse(
    localStorage.getItem("feedback")
  );
  const fromLocalStorageTitle = JSON.parse(localStorage.getItem("title"));

  useEffect(() => {
    if (fromLocalStorageFeedbacks) {
      setFeedback(fromLocalStorageFeedbacks);
    } else if (feedback.length === 0) {
      API.get("/feedback")
        .then((res) => {
          setFeedback(res.data.data);
          localStorage.setItem("feedback", JSON.stringify(res.data.data));
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (fromLocalStorageTitle) {
      setTitle(fromLocalStorageTitle);
    } else if (!title) {
      API.get("/title")
        .then((res) => {
          setTitle(res.data.data.title);
          localStorage.setItem("title", JSON.stringify(res.data.data.title));
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /*TO PREVENT SCREEN FROM TURNING OFF*/

  // const [screenLock, setScreenLock] = useState();

  // const getScreenLock = async () => {
  //   if ("wakeLock" in navigator) {
  //     try {
  //       const tempScreenLock = await navigator.wakeLock.request("screen");
  //       setScreenLock(tempScreenLock);
  //     } catch (err) {
  //       console.log(err.name, err.message);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   getScreenLock();
  // }, []);

  // if (!screenLock) {
  //   return <h1>Browser not supported</h1>;
  // }

  return (
    <>
      <Router>
        <Routes>
          <Route path="/thankyou" element={<ThankYou />} />
          <Route
            path="/*"
            element={<HomePage feedback={feedback} title={title} />}
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
